import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private _showBanner: boolean;
  
  constructor() {
    this._showBanner = false;
  }

  public processError(err: any): void {
    this._showBanner = true;
  }

  public get showBanner() {
    return this._showBanner;
  }
}
